import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const pokemonApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: 'https://pokeapi.co/api/v2/' }),
    reducerPath: 'pokemonApi',
    endpoints: (build) => ({
        getPokemonByName: build.query<any, string>({
            query: (name) => `pokemon/${name}`,
        }),
        updatePost: build.mutation<any, Partial<any> & Pick<any, 'id'>>({
            query: ({ id, ...patch }) => ({
                url: `post/${id}`,
                method: 'PATCH',
                body: patch,
            }),
        }),
    }),
})

export const { 
    useGetPokemonByNameQuery,
    useUpdatePostMutation,
} = pokemonApi
